export default {
  label: "text-color",
  valueScope:[
    'text-primary',
    'text-secondary',
    'text-success',
    'text-danger',
    'text-warning',
    'text-info',
    'text-light',
    'text-dark',
    'text-muted',
    'text-white',
  ]
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/color.js